import { Component } from '@angular/core';

/**
 * IntelliMPN brand mark and wordmark (Figma "IntelliMPN logo").
 *
 * The wordmark inherits the current text colour so it follows the light/dark theme, while the
 * mark keeps its brand gradient in both themes. Narrow viewports keep only the 40px mark visible.
 */
@Component({
  selector: 'app-logo',
  templateUrl: './logo.html',
  host: { class: 'block h-6 w-10 shrink-0 overflow-hidden text-inherit md:w-[164px]' },
})
export class Logo { }
